import { alphabeticalSort } from '@cims-online/shared'
import CIMSCollapse from 'components/CIMSCollapse'
import { useIssueNotificationsContext } from '../../../../../IssueNotificationsContext'
import TypeFallback from '../../../../../components/TypeFallback'
import { TypeFormItemsProps, TypeItem } from './types'
import CIMSFormItem from 'components/CIMSFormItem'
import RecipientsSelect from 'components/CIMSSelect/common/RecipientsSelect'
import { useState } from 'react'
import { LabeledValueType } from 'components/CIMSSelect/types'

const TypeFormItems: React.VFC<TypeFormItemsProps> = ({ onChange, value }) => {
  const { types } = useIssueNotificationsContext()
  const [values, setValues] = useState<Map<string, TypeItem>>(
    (value ?? []).reduce(
      (map, v) => map.set(v.typeId, v),
      new Map<string, TypeItem>()
    )
  )
  const change = (id: string, recipients: LabeledValueType[]) => {
    setValues((prev) => {
      const map = new Map(prev)
      map.set(id, { typeId: id, recipients })
      onChange?.([...map.values()])
      return map
    })
  }
  return (
    <CIMSCollapse
      noPanelsContent={<TypeFallback />}
      panels={types
        .sort(alphabeticalSort('name'))
        .map(({ id, name, description }) => ({
          key: id,
          header: {
            type: 'described',
            name,
            description,
          },
          children: (
            <CIMSFormItem label="Recipients">
              <RecipientsSelect
                value={values.get(id)?.recipients ?? []}
                onChange={(recipients) =>
                  change(id, recipients as LabeledValueType[])
                }
              />
            </CIMSFormItem>
          ),
        }))}
    />
  )
}

export default TypeFormItems
